<template>

    <div class="row h-100 justify-content-center align-items-center bg-warning text-light">

        <div class="col-sm-8 col-11" v-if="project">

            <h1>Proyecto</h1>

            <div class="form-group mt-4">

                <label for="project_nombre">¿En que parte del Pathway se puede implementar?</label>

                <div class="text-left">

                    <div class="custom-control custom-checkbox" v-for="choice in choices" :key="choice">

                        <input
                            type="checkbox"
                            :value="choice"
                            :id="`check-` + choice"
                            v-model="project.pathway"
                            class="custom-control-input"
                        />

                        <label class="custom-control-label" :for="`check-` + choice">{{ choice }}</label>

                    </div>

                </div>

            </div>

            <button class="btn w-100 btn-light btn-lg mt-4" :disabled="disabled" @click="set"> Siguiente </button>

        </div>

    </div>

</template>

<script>
import router from "../router";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            project: null,
            choices: ["Input", "Awareness", "Experiences", "Sustainment", "Output"],
            ...mapGetters(["getProject"]),
        };
    },
    mounted() {
        this.project = this.getProject();
    },
    computed: {
        disabled: function() {
            return this.project.pathway.length == 0;
        },
    },
    methods: {
        set() {
            this.setProject(this.project);
            router.push("Project3");
        },
        ...mapActions(["setProject"]),
    },
};
</script>

